/**
 * Utility functions for converting species scientific names to URL-friendly slugs
 */

/**
 * Convert a scientific name to a URL-friendly slug
 * @param scientificName - The scientific name (e.g., "Asimina triloba")
 * @returns URL-friendly slug (e.g., "asimina-triloba")
 */
export const getSpeciesSlug = (scientificName: string): string => {
  return scientificName
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};

/**
 * Convert a URL slug back to a scientific name
 * @param slug - The URL slug (e.g., "asimina-triloba")
 * @returns Scientific name (e.g., "Asimina triloba")
 */
export const getScientificNameFromSlug = (slug: string): string => {
  return slug
    .split('-')
    .map((word, index) => {
      // First word gets first letter capitalized, rest lowercase
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      // Subsequent words are all lowercase (species epithet)
      return word.toLowerCase();
    })
    .join(' ');
};
